import SettingsIcon from '~/shared/assets/icons/settings.svg';
import GridIcon from '~/shared/assets/icons/grid.svg';
import AnalyticsIcon from '~/shared/assets/icons/analytics.svg';
import DashboardIcon from '~/shared/assets/icons/dashboard-icon.svg';

export const sidebarItems: SidebarItemType[] = [
  {
    title: 'Fleet Manager',
    icon: { el: DashboardIcon, colorMode: 'stroke' },
    pathname: '/fleet-manager',
  },
  {
    title: 'EBS Analytics',
    icon: { el: AnalyticsIcon },
    pathname: '/analytics',
    isDisabed: true,
  },
  {
    title: 'Log',
    icon: { el: GridIcon },
    pathname: '/log',
  },
  {
    title: 'Settings',
    icon: { el: SettingsIcon, colorMode: 'stroke' },
    pathname: '/settings',
  },
];

export type SidebarItemType = {
  title: string;
  icon: { el: typeof DashboardIcon; colorMode?: 'stroke' | 'fill' };
  pathname: string;
  isDisabed?: boolean;
};
